import React, { useState, useEffect } from 'react';
import api from '../services/api';

const STATUS_COLORS = { pending: '#f59e0b', confirmed: '#3b82f6', shipped: '#8b5cf6', delivered: '#10b981', cancelled: '#ef4444' };

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('orders/')
      .then(res => setOrders(res.data.results || res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p style={{ textAlign: 'center', padding: 60, color: '#999' }}>Loading...</p>;

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '40px 20px' }}>
      <h2 style={{ fontSize: 22, fontWeight: 300, letterSpacing: 1, marginBottom: 32 }}>My Orders</h2>
      {orders.length === 0 ? (
        <p style={{ color: '#999', textAlign: 'center' }}>No orders yet.</p>
      ) : (
        orders.map(order => (
          <div key={order.id} style={{ border: '1px solid #eee', marginBottom: 12 }}>
            <div onClick={() => setExpanded(expanded === order.id ? null : order.id)}
              style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px', cursor: 'pointer' }}>
              <div>
                <span style={{ fontWeight: 500 }}>#{order.order_number || order.id}</span>
                <span style={{ color: '#999', marginLeft: 12, fontSize: 13 }}>{new Date(order.created_at).toLocaleDateString()}</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <span style={{ padding: '4px 10px', borderRadius: 12, fontSize: 12, color: '#fff', background: STATUS_COLORS[order.status?.toLowerCase()] || '#999' }}>
                  {order.status}
                </span>
                <span style={{ fontWeight: 500 }}>₹{order.total}</span>
              </div>
            </div>
            {expanded === order.id && (
              <div style={{ padding: '0 16px 16px', borderTop: '1px solid #eee' }}>
                {order.items?.map((item, i) => (
                  <div key={i} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', fontSize: 14 }}>
                    <span>{item.product_name || item.product?.name} × {item.quantity}</span>
                    <span>₹{item.price * item.quantity}</span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
}
